import React from "react";
import Header from "Component/Header/Header";
import Footer from "Component/Footer/Footer";
import SingleBlog from "Pages/Home/SingleBlog";

const BlogDetailTheme = () => {
  return (
    <>
      <Header />
      <SingleBlog />
      <Footer />
    </>
  );
};

export default BlogDetailTheme;